import { products } from "views/components/pages/PharmacyAI/constants";
import { PageContainer } from "views/components/pages/PharmacyAI/layout";
import {
  PillIcon,
  ProductGrid,
  ProductPill,
  ProductsPanel,
  ProductsSection,
  SectionEyebrow,
  SectionTitle,
} from "./styles";

const Products = () => {
  return (
    <ProductsSection>
      <PageContainer>
        <SectionEyebrow>Our products</SectionEyebrow>
        <SectionTitle>Building blocks for your workflow</SectionTitle>
        <ProductsPanel>
          <ProductGrid>
            {products.map((name, index) => (
              <ProductPill key={name}>
                <PillIcon $hue={(index * 37) % 360} aria-hidden />
                <span>{name}</span>
              </ProductPill>
            ))}
          </ProductGrid>
        </ProductsPanel>
      </PageContainer>
    </ProductsSection>
  );
};

export default Products;
